import { render, staticRenderFns } from "./capitalExpenditure.vue?vue&type=template&id=134397ba&scoped=true"
import script from "./capitalExpenditure.vue?vue&type=script&lang=js"
export * from "./capitalExpenditure.vue?vue&type=script&lang=js"
import style0 from "./capitalExpenditure.vue?vue&type=style&index=0&id=134397ba&prod&scoped=scoped&lang=scss"
import style1 from "./capitalExpenditure.vue?vue&type=style&index=1&id=134397ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134397ba",
  null
  
)

export default component.exports